export default __webpack_public_path__ + "static/media/crossForClose.f4fbf7d5.svg";